<template>
    <div>

      <div class="mb-4">
        <div class="font-weight-bold">What is your target audience?</div>
        <div class="mt-2">POP AI will use this information to match the content intent.</div>
      </div>

      <div>
        <div>
          <v-textarea
            outlined
            dense
            :value="targetAudience"
            @input="$emit('update:targetAudience', $event)"
            color="greenColor"
            counter="250"
            placeholder="Add description"
            :counter-value="countWords"
            :rules="[(v) => countWords(v) <= 250 || `Must be less than 250 words`]"
          >
          </v-textarea>
        </div>
      </div>

    </div>
</template>

<script>

export default {
    name: 'ConfigTargetAudience',
    props: [

        'countWords',
        'targetAudience',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>